import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';
import './About.scss';
import { urlFor, client } from '../../client';
import { images } from '../../constants';
import { FaAward } from 'react-icons/fa'
import { FiUsers } from 'react-icons/fi'
import { VscFolderLibrary } from 'react-icons/vsc'
import ME from '../../assets/profile.png'
import { MdEngineering } from 'react-icons/md'
import { BsDot } from 'react-icons/bs'
import { AiOutlineArrowRight, AiOutlineClose, AiOutlineCheck } from 'react-icons/ai'
import { GiSkills, GiFlexibleStar } from 'react-icons/gi'
import { Ri24HoursLine } from 'react-icons/ri'



const About = () => {
  const [style5, setStyle5] = useState('abouts__modal');

  const [style1, setStyle1] = useState('abouts__modal');

  const [style2, setStyle2] = useState('abouts__modal');

  const [style3, setStyle3] = useState('abouts__modal');

  const [style4, setStyle4] = useState('abouts__modal');



  const changeStyle1 = () => {
    setStyle1('abouts__modal-reveal')
  }

  const changeStyle2 = () => {
    setStyle2('abouts__modal-reveal')
  }

  const changeStyle3 = () => {
    setStyle3('abouts__modal-reveal')
  }

  const changeStyle4 = () => {
    setStyle4('abouts__modal-reveal')

  }

  const changeStyle5 = () => {
    setStyle5('abouts__modal-reveal')
  }

  const cancelStyle = () => {
    setStyle1('abouts__modal')
    setStyle2('abouts__modal')
    setStyle3('abouts__modal')
    setStyle4('abouts__modal')
    setStyle5('abouts__modal')
  }
  return (
    <section id='About'>
      <div className='top__titles'>
        <h2 className='head-text' >About Me</h2>

      </div>






      <div

        className="container about__container"
      >

        <div className='about__content'>
          <div className="about__cards">


            <article className='about__card'>
              <MdEngineering className='about__icon' />
              <div className='about__title'>
                <h3>Education</h3>
                <p className='p-text'>Student</p>
              </div>
              <span className="about__button" onClick={changeStyle1}>
                Learn more <AiOutlineArrowRight className='about__icon1' />
              </span>


              <div className={style1}>
                <div className="abouts__modal-content">
                  <AiOutlineClose className='abouts__modal-close' onClick={cancelStyle} />

                  <h3 className="abouts__modal-title">
                    Computer Science
                  </h3>
                  <p className="abouts__modal-description">
                    Currently getting my bachelor's degree in the field of computer science
                  </p>
                  <ul className="abouts__modal-list">
                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        I am currently a 300level student of the department of computer science, University of Benin (UNIBEN).

                      </p>
                    </li>

                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        I had my secondary education at Uniben Demonstaration Secondary School (UDSS), Benin City.
                      </p>
                    </li>

                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        I plan on doing developing my skills both in computer science and software engineering.
                      </p>
                    </li>


                  </ul>

                </div>
              </div>
            </article>









            <article className='about__card'>
              <FaAward className='about__icon' />
              <div className='about__title'>
                <h3>Experience</h3>
                <p className='p-text'>10+ Projects</p>
              </div>
              <span className="about__button" onClick={changeStyle2}>
                Learn More <AiOutlineArrowRight className='about__icon1' />
              </span>

              <div className={style2}>
                <div className="abouts__modal-content">
                  <AiOutlineClose className='abouts__modal-close' onClick={cancelStyle} />

                  <h3 className="abouts__modal-title">
                    Experience
                  </h3>
                  <p className="abouts__modal-description">
                    Over 10 completed projects for clients and still counting
                  </p>
                  <ul className="abouts__modal-list">
                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        I have worked with teams to build wonderfull
                        projects.
                      </p>
                    </li>


                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        I am current part of the xpace team as a backend and blockchain developer.
                      </p>
                    </li>

                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        I have over 2 years experience in BlockChain and Data Science.
                      </p>
                    </li>



                  </ul>

                </div>
              </div>
            </article>









            <article className='about__card'>
              <GiFlexibleStar className='about__icon' />
              <div className='about__title'>
                <h3>Flexibility</h3>
                <p className='p-text'>4+ languages</p>
              </div>

              <span className="about__button" onClick={changeStyle3}>
                Learn more <AiOutlineArrowRight className='about__icon1' />
              </span>


              <div className={style3}>
                <div className="abouts__modal-content">
                  <AiOutlineClose className='abouts__modal-close' onClick={cancelStyle} />

                  <h3 className="abouts__modal-title">
                    Flexibility
                  </h3>
                  <p className="abouts__modal-description">
                    I have learnt, studied, and used over 4 programming languages with various
                    technologies to achieve my goals
                  </p>
                  <ul className="abouts__modal-list">
                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        I have developed myself to be versatile various programming languages, frameworks and technologies
                      </p>
                    </li>

                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        I have deep dive into trending and new technologies so as to improve my IT skills
                      </p>
                    </li>

                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        Some of the programming languages include: Python, Javascript, Solidity, PHP,
                        SQL, R etc
                      </p>
                    </li>

                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        Some of the technologies include: Tableau, Spss, Power Bi Nfts, Thirdweb, Alchemy, Infura
                      </p>
                    </li>




                  </ul>

                </div>
              </div>
            </article>








            <article className='about__card'>
              <Ri24HoursLine className='about__icon' />
              <div className='about__title'>
                <h3>Available</h3>
                <p className='p-text'>24/7</p>
              </div>

              <span className="about__button" onClick={changeStyle4}>
                Learn more <AiOutlineArrowRight className='about__icon1' />
              </span>

              <div className={style4}>
                <div className="abouts__modal-content">
                  <AiOutlineClose className='abouts__modal-close' onClick={cancelStyle} />

                  <h3 className="abouts__modal-title">
                    Available
                  </h3>
                  <p className="abouts__modal-description">
                    I am always availabe at the clock to attend to your needs
                  </p>
                  <ul className="abouts__modal-list">
                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        I am fluent in English, dedicated, patient, focused and also fun to work with
                      </p>
                    </li>

                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        I am a Data Scientist and BlockChain Developer by trade but i also specialize in multiple areas
                      </p>
                    </li>

                    <li className="abouts__modal-item">
                      <BsDot className='abouts__modal-icon' />
                      <p className="abouts__modal-info">
                        I am just a click of a button away from fulfilling your needs. Contact me now!
                      </p>
                    </li>



                  </ul>

                </div>
              </div>
            </article>

          </div>


          <div className='extra__info'>
            <p className=' about__text'>
              I am a full stack web developer by trade but i also specialize in web3 (blockchain) development and Web Development and Design. I am conversant with multiple programming languages, frameworks, technologies and problem solving techniques . I am eager to join the working community and deliver quality services to my clients. Previous working experience although not much has taught me a lot of things that will help me keep improving as a software engineer. I have received numerous positive
              reviews from my clients themselves for superb customer service and communication skills.
            </p>


            <a href="#contact" className='btn btn-primary'>Let's Talk</a>

          </div>

        </div>

      </div>


    </section>
  );
};

export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  'app__whitebg',
);